import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import { Controller } from 'react-hook-form';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import { ErrorWithIcon } from '@ui/components/common/TextField/ErrorWithIcon';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import { ArrowDown2 } from 'iconsax-react';
import { Box } from '@mui/material';
import { REGISTRATION_FIELD_FILL_BG } from '../registrationFormFieldStyles';
import InfoIconTooltip from '@ui/components/common/Tooltips/InfoIconTooltip';
const ESelect = ({ name, control, label, options, rules, error, tooltipText, bgColor = REGISTRATION_FIELD_FILL_BG, ...rest }) => {
    const styledLabel = useMemo(() => !label ? undefined : (_jsxs(Box, { display: 'inline-flex', alignItems: 'center', gap: '4px', sx: { pointerEvents: 'auto' }, children: [_jsx(InputLabel, { children: label }), tooltipText && (_jsx(Box, { sx: {
                    display: 'inline-flex',
                    alignItems: 'center',
                    pointerEvents: 'auto',
                    cursor: 'pointer'
                }, children: _jsx(InfoIconTooltip, { title: tooltipText, size: 'small', variant: 'dark' }) }))] })), [label, tooltipText]);
    return (_jsxs(FormControl, { fullWidth: true, variant: 'filled', sx: {
            '& .MuiFormLabel-root.MuiInputLabel-root': {
                maxWidth: 'calc(100% - 60px)',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap'
            },
            '& .MuiFormLabel-root.MuiInputLabel-shrink': { maxWidth: '100%' }
        }, children: [label && (_jsxs(InputLabel, { sx: { display: 'inline-flex', alignItems: 'center', gap: '4px' }, children: [label, tooltipText && (_jsx(Box, { component: 'span', sx: {
                            display: 'inline-flex',
                            alignItems: 'center',
                            cursor: 'pointer',
                            pointerEvents: 'auto',
                            mr: '4px'
                        }, children: _jsx(InfoIconTooltip, { title: tooltipText, size: 'small', variant: 'dark' }) }))] })), _jsx(Controller, { name: name, control: control, rules: rules, render: ({ field }) => (_jsx(Select, { ...field, label: styledLabel, ...rest, variant: 'filled', IconComponent: (props) => _jsx(ArrowDown2, { ...props, size: 16, color: '#454F5B' }), sx: {
                        backgroundColor: bgColor,
                        pr: 5,
                        '&:hover': {
                            backgroundColor: bgColor
                        },
                        '&.Mui-focused': {
                            backgroundColor: bgColor
                        },
                        '& .MuiSelect-icon': {
                            color: '#454F5B',
                            right: 16
                        }
                    }, children: options.map((opt) => (_jsx(MenuItem, { sx: { fontWeight: 400 }, value: opt.value, children: opt.label }, opt.value))) })) }), _jsx(ErrorWithIcon, { error: error, mt: 0.5, ml: 0.5 })] }));
};
export default ESelect;
